module.exports = __webpack_public_path__ + "static/media/105-cameroon.141652e4.svg";